import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ThemeToggle from "./ThemeToggle";
import { useAuth } from "../context/AuthContext";
import { hasPermission, PERM } from "../permissions";

const Icons = {
  Team: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  ),
  Chart: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="18" y1="20" x2="18" y2="10"></line>
      <line x1="12" y1="20" x2="12" y2="4"></line>
      <line x1="6" y1="20" x2="6" y2="14"></line>
    </svg>
  ),
  Heatmap: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="3" width="7" height="7"></rect>
      <rect x="14" y="3" width="7" height="7"></rect>
      <rect x="14" y="14" width="7" height="7"></rect>
      <rect x="3" y="14" width="7" height="7"></rect>
    </svg>
  ),
  Tasks: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="3" width="7" height="18" rx="1"></rect>
      <rect x="14" y="3" width="7" height="12" rx="1"></rect>
      <line x1="5" y1="7" x2="8" y2="7"></line>
      <line x1="5" y1="11" x2="8" y2="11"></line>
      <line x1="16" y1="7" x2="19" y2="7"></line>
    </svg>
  ),
  Calendar: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
  ),
  Settings: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="3"></circle>
      <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"></path>
    </svg>
  ),
  Users: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
      <circle cx="9" cy="7" r="4"></circle>
      <path d="M22 21v-2a4 4 0 0 0-3-3.87"></path>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
    </svg>
  ),
  Clients: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 21h18"></path>
      <path d="M5 21V7l8-4v18"></path>
      <path d="M19 21V11l-6-4"></path>
      <line x1="9" y1="9" x2="9" y2="9.01"></line>
      <line x1="9" y1="13" x2="9" y2="13.01"></line>
    </svg>
  ),
  Kontur: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="5" width="20" height="14" rx="2"></rect>
      <line x1="2" y1="10" x2="22" y2="10"></line>
    </svg>
  ),
  Payments: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="6" width="20" height="14" rx="2"></rect>
      <circle cx="12" cy="13" r="3"></circle>
      <path d="M6 6V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1"></path>
    </svg>
  ),
  Finance: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="2" y="6" width="20" height="14" rx="2"></rect>
      <circle cx="12" cy="13" r="3"></circle>
      <path d="M6 6V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v1"></path>
    </svg>
  ),
  Manager: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="8" r="4"></circle>
      <path d="M5.5 21a7.5 7.5 0 0 1 13 0"></path>
      <path d="M12 2v1"></path>
    </svg>
  ),
  Pulse: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
    </svg>
  ),
  UserPlus: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
      <circle cx="8.5" cy="7" r="4"></circle>
      <line x1="20" y1="8" x2="20" y2="14"></line>
      <line x1="17" y1="11" x2="23" y2="11"></line>
    </svg>
  ),
  Vpn: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
      <path d="M9.5 12.5l1.5 1.5 3.5-3.5"></path>
    </svg>
  ),
  Book: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>
    </svg>
  ),
  Bell: () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path>
      <path d="M13.73 21a2 2 0 0 1-3.46 0"></path>
    </svg>
  ),
};

const ALL_NAV_SECTIONS = [
  {
    title: "Обзор",
    links: [
      { path: "/executive", label: "Командный центр", icon: Icons.Pulse, permission: PERM.EXECUTIVE_VIEW },
    ],
  },
  {
    title: "Опросы",
    links: [
      { path: "/", label: "Команда за неделю", icon: Icons.Team, permission: PERM.SURVEYS_VIEW },
      { path: "/dynamics", label: "Динамика по времени", icon: Icons.Chart, permission: PERM.SURVEYS_VIEW },
      { path: "/clients", label: "Загрузка по клиентам", icon: Icons.Heatmap, permission: PERM.SURVEYS_VIEW },
    ],
  },
  {
    title: "Руководитель",
    links: [
      { path: "/manager", label: "Ежедневные отчёты", icon: Icons.Manager, permission: PERM.MANAGER_REPORTS_VIEW },
    ],
  },
  {
    title: "Операции",
    links: [
      { path: "/tasks", label: "Задачи", icon: Icons.Tasks, permission: PERM.TASKS_ACCESS },
      { path: "/client-directory", label: "Клиенты", icon: Icons.Clients, permission: PERM.CLIENTS_ACCESS },
      { path: "/client-reminders", label: "Напоминания", icon: Icons.Bell, permission: PERM.CLIENTS_ACCESS },
      { path: "/client-payments", label: "Оплаты клиентов", icon: Icons.Payments, permission: PERM.CLIENTS_FEE },
      { path: "/kontur-payments", label: "Оплаты Контура", icon: Icons.Kontur, permission: PERM.KONTUR_ACCESS },
      { path: "/finance", label: "Финансы", icon: Icons.Finance, permission: PERM.FINANCE_ACCESS },
      { path: "/vacations", label: "График отпусков", icon: Icons.Calendar, permission: PERM.VACATIONS_ACCESS },
    ],
  },
  {
    title: "Компания",
    links: [
      { path: "/regulations", label: "Регламенты", icon: Icons.Book },
    ],
  },
  {
    title: "Аккаунт",
    links: [
      { path: "/settings", label: "Настройки", icon: Icons.Settings, permission: PERM.SETTINGS_ACCESS },
      { path: "/employees", label: "Сотрудники", icon: Icons.UserPlus, permission: PERM.EMPLOYEES_MANAGE },
      { path: "/users", label: "Пользователи", icon: Icons.Users, permission: PERM.USERS_MANAGE },
      { path: "/vpn-admin", label: "VPN", icon: Icons.Vpn, permission: PERM.VPN_ADMIN },
    ],
  },
];

export default function Sidebar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, roleLabel, logout } = useAuth();
  let linkIndex = 0;

  const navSections = ALL_NAV_SECTIONS.map((section) => ({
    ...section,
    links: section.links.filter((l) => !l.permission || hasPermission(user, l.permission)),
  })).filter((section) => section.links.length > 0);

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <nav className="sidebar">
      <h1 className="sidebar-title" translate="no">VITA</h1>
      <p className="sidebar-subtitle">Платформа</p>
      {navSections.map((section) => (
        <div key={section.title} className="sidebar-section">
          <h2 className="sidebar-section-title">{section.title}</h2>
          <ul className="sidebar-nav">
            {section.links
              .map((l) => {
              const Icon = l.icon;
              const isActive =
                l.path === "/"
                  ? location.pathname === "/"
                  : location.pathname === l.path || location.pathname.startsWith(`${l.path}/`);
              const delay = linkIndex++;
              return (
                <li
                  key={l.path}
                  className={isActive ? "active" : ""}
                  style={{ animationDelay: `${delay * 0.1}s` }}
                >
                  <Link to={l.path}>
                    <span className="nav-icon">
                      <Icon />
                    </span>
                    <span translate={l.path === "/kontur-payments" ? "no" : undefined}>{l.label}</span>
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      ))}

      <div style={{
        marginTop: "auto",
        padding: "20px 0",
        borderTop: "1px solid var(--border-color)",
      }}>
        {user && (
          <div className="sidebar-user">
            <div className="sidebar-user-name">
              {user.display_name || user.username}
            </div>
            <div className="sidebar-user-role">{roleLabel}</div>
            <button type="button" className="sidebar-logout" onClick={handleLogout}>
              Выйти
            </button>
          </div>
        )}

        <div style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "16px",
        }}>
          <span style={{
            fontSize: "12px",
            color: "var(--text-muted)",
            fontWeight: 500,
          }}>
            Тема оформления
          </span>
          <ThemeToggle />
        </div>

        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "12px",
          fontSize: "12px",
          color: "var(--text-muted)",
          opacity: 0.8,
        }}>
          <div style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            background: "var(--score-high)",
            animation: "pulse 2s ease-in-out infinite",
            transformOrigin: "center",
            boxShadow: "0 0 8px var(--score-high)",
          }} />
          <span>Система активна</span>
        </div>
      </div>
    </nav>
  );
}
